<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="设备uuid：" prop="device_id">
                    <el-input v-model.trim="form.device_id" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="uid：" prop="uid">
                    <el-input v-model.trim="form.uid" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="属性/事件：" prop="identifier">
                    <el-select v-model="form.identifier" placeholder="请选择" filterable clearable>
                        <el-option v-for="item in identifierList" :key="item.key" :label="item.value"
                            :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间范围：" prop="createTime">
                    <el-date-picker v-model="createTime" type="datetimerange" start-placeholder="开始时间"
                        end-placeholder="结束时间" format="YYYY-MM-DD HH:mm:ss" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div v-if="chartReady" id="identifierValuesChart" class="chart-box"></div>
        <div v-else-if="searched" class="chart-box empty-box">暂无数据</div>

        <el-table v-if="tableData.length > 0" :data="tableData" size="mini" border style="margin-top: 20px;">
            <el-table-column prop="created_at" label="时间" min-width="180" />
            <el-table-column prop="device_id" label="设备uuid" min-width="150" />
            <el-table-column prop="identifier" label="属性/事件" min-width="150">
                <template v-slot="scope">
                    <span>{{ getLabel(scope.row.identifier) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="value" label="值" min-width="120" />
        </el-table>
    </div>
</template>

<script>
import { onMounted, onBeforeUnmount, reactive, ref, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import api from '../../../axios/api'
import dayjs from 'dayjs'
import * as echarts from 'echarts'

export default {
    name: 'identifierValues',
    setup() {
        const form = reactive({
            device_id: '',
            uid: '',
            identifier: ''
        })
        const formRef = ref()
        const identifierList = ref([])
        const createTime = ref('')
        const tableData = ref([])
        const chartReady = ref(false)
        const searched = ref(false)
        let myChart = null
        let identifierMap = {}

        const getOnlineIdentifierList = async () => {
            const res = await api.OnlineIdentifierValueList({})
            if (res.data.code === 200) {
                const list = res.data.data.list || []
                identifierList.value = list
                identifierMap = {}
                list.forEach(item => { identifierMap[item.key] = item.value })
            }
        }

        const getLabel = (key) => identifierMap[key] || key

        const renderChart = (list) => {
            const chartDom = document.getElementById('identifierValuesChart')
            if (!chartDom) return
            if (myChart) myChart.dispose()
            myChart = echarts.init(chartDom)

            const xData = list.map(item => item.created_at)
            const label = getLabel(form.identifier)

            myChart.setOption({
                tooltip: { trigger: 'axis', axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } } },
                legend: { data: [label], top: 0 },
                grid: { left: '3%', right: '4%', bottom: '3%', top: 40, containLabel: true },
                toolbox: { feature: { saveAsImage: {} } },
                xAxis: { type: 'category', boundaryGap: false, data: xData, axisLabel: { rotate: xData.length > 20 ? 45 : 0 } },
                yAxis: { type: 'value' },
                series: [{
                    name: label,
                    type: 'line',
                    smooth: true,
                    areaStyle: { opacity: 0.15 },
                    itemStyle: { color: '#5470c6' },
                    data: list.map(item => Number(item.value) || 0)
                }]
            })
        }

        const handleResize = () => { if (myChart) myChart.resize() }

        const onSearch = async () => {
            if (!form.device_id) { ElMessage.error('请输入设备uuid'); return }
            if (!form.identifier) { ElMessage.error('请选择属性/事件'); return }
            if (!createTime.value) { ElMessage.error('请选择时间范围'); return }

            const params = {
                device_id: form.device_id,
                identifier: form.identifier,
                start_time: dayjs(createTime.value[0]).format('YYYY-MM-DD HH:mm:ss'),
                end_time: dayjs(createTime.value[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            if (form.uid) params.uid = form.uid

            const res = await api.OnlineIdentifierValues(params)
            searched.value = true
            if (res.data.code === 200 && res.data.data) {
                const list = res.data.data.list || []
                if (list.length > 0) {
                    list.forEach(item => {
                        item.created_at = dayjs(item.created_at).format('YYYY-MM-DD HH:mm:ss')
                    })
                    tableData.value = list
                    chartReady.value = true
                    nextTick(() => {
                        renderChart(list)
                        window.addEventListener('resize', handleResize)
                    })
                } else {
                    tableData.value = []; chartReady.value = false
                }
            } else {
                ElMessage.error(res.data.msg || '查询失败')
                tableData.value = []; chartReady.value = false
            }
        }

        const resetForm = (formEl) => {
            if (formEl) formEl.resetFields()
            form.device_id = ''; form.uid = ''; form.identifier = ''
            createTime.value = ''
            tableData.value = []
            chartReady.value = false; searched.value = false
            if (myChart) { myChart.dispose(); myChart = null }
        }

        onMounted(() => { getOnlineIdentifierList() })
        onBeforeUnmount(() => {
            window.removeEventListener('resize', handleResize)
            if (myChart) myChart.dispose()
        })

        return {
            form, formRef, identifierList, createTime,
            tableData, chartReady, searched,
            getLabel, onSearch, resetForm
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
			opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
	::v-deep(tbody) {
		tr {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
			opacity: 0.8;
		}
	}
	.chart-box {
		width: 100%;
		height: 400px;
	}
	.empty-box {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #909399;
		font-size: 14px;
	}
}
</style>